import React, { FunctionComponent, useEffect } from 'react';
import { PageHeader } from '../../components';
import { trackerRoutes } from '../../routes/private';
import { useLocation } from 'react-router';
import { history } from '../../history';
import { useReviewProgress } from '../../hooks';
import {
  ContactButton,
  SubmissionCompleteContainer,
} from '../../components/SubmissionComplete';

export const PizzaTrackerPage: FunctionComponent = () => {
  const { reviewStepIndex } = useReviewProgress();
  const { pathname } = useLocation();

  useEffect(() => {
    // calculate the correct route the user is supposed to be on
    if (typeof reviewStepIndex === 'number') {
      const [routeItem] = trackerRoutes;
      const currentIndex = routeItem.paths!.findIndex(path => path === pathname);
      const correctIndex = reviewStepIndex;

      if (!isNaN(correctIndex) && correctIndex !== currentIndex) {
        history.push(routeItem.paths![correctIndex]);
      }
    }
  }, [pathname, reviewStepIndex]);

  return (
    <>
      <PageHeader
        id="pizza-tracker-header"
        data-testid="pizza-tracker-header"
      />
      <SubmissionCompleteContainer />
      <ContactButton />
    </>
  );
};
